<script>
    import { Router, Link, Route } from "svelte-routing";
    import ListRoute from "./list/list.html";
    import AddUpdate from "./addupdate/update.html";
    import MODULES from "../utils/modules.js" 
    import Forbidden from "../forbidden.html"
</script>

<Router>

    <Route path="add" >
        <AddUpdate></AddUpdate>
    </Route>
    <Route path="edit/:id" let:params>
        {#if MODULES.hasAccess(MODULES.VIEW_BATCH_DETAILS)}
        <AddUpdate _id="{params.id}"></AddUpdate>
        {:else}
        <Forbidden />
        {/if}
    </Route>
    <Route path="">
        <ListRoute></ListRoute>
    </Route>
</Router>



